// lib/utils/domain-error-translator.ts
import type { TFunction } from 'i18next';

export class DomainMutationError extends Error {
  constructor(readonly code: string) {
    super(code);
    this.name = 'DomainMutationError';
  }
}

export function getErrorDomainCode(error: unknown): string {
  return error instanceof DomainMutationError ? error.code : 'unknown';
}

export function getDomainErrorMessage(
  code: string,
  t: TFunction,
  defaultMessageKey: string
): string {
  return t(`domain_errors.${code}.message`, {
    defaultValue: t(defaultMessageKey),
  });
}

export interface ShowDomainErrorToastParams {
  toast: (opts: {
    title: string;
    description: string;
    variant: 'destructive';
  }) => void;
  t: TFunction;
  code: string;
  titleKey: string;
  defaultMessageKey: string;
  clearProgress?: () => void;
}

export function showDomainErrorToast({
  toast,
  t,
  code,
  titleKey,
  defaultMessageKey,
  clearProgress,
}: ShowDomainErrorToastParams): void {
  clearProgress?.();
  const description = getDomainErrorMessage(code, t, defaultMessageKey);
  toast({
    title: t(titleKey),
    description,
    variant: 'destructive',
  });
}
